import React, { useEffect } from "react";
import PopImage from "../components/PopImage";
import {
  Page,
  HeroWrap,
  Label,
  Headline,
  SubtitleRow,
  HeroImage,
  SectionHeader,
  ChallengeSection,
  MetricCard,
  SolutionGrid,
  ResultsSection
} from "../components/CaseStudyLayout";

import bpHero from "../images/bp/ff01.png";
import bp1 from "../images/bp/bp1.jpg";
import bp3 from "../images/bp/bp3.jpg";
import bp4 from "../images/bp/bp4.jpg";
import bp5 from "../images/bp/bp5.jpg";

const BP = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Page>
      <HeroWrap>
        <Label>CHOREOGRAPHY & DANCE — RESIDENCY</Label>
        <Headline>Body Politic</Headline>
        <SubtitleRow>
          <p>
            Choreographer, director, and dancer residency with the contemporary hip-hop dance company Body Politic ('14 — '17).
            Collaborating on full-length theater shows, choreographing live showcases, and directing digital campaigns.
          </p>
          <div className="meta">
            <strong>ROLE</strong>
            <span>Choreographer, Dancer & Director</span>
            <strong>SECTOR</strong>
            <span>Contemporary Dance & Theater</span>
          </div>
        </SubtitleRow>
      </HeroWrap>

      <HeroImage>
        <PopImage src={bpHero} alt="Body Politic Hero" title="Body Politic Dance Residency" />
      </HeroImage>

      <ChallengeSection>
        <div className="left">
          <h2>The Residency</h2>
          <p>
            During my multi-year tenure with the contemporary hip-hop theater company Body Politic, my goal was to merge raw hip-hop foundations with structured contemporary theatrical narratives.
            The focus was on utilizing human bodies as architectural structures to convey complex psychological themes such as mental health vulnerability, societal pressure, and collective resilience.
          </p>
          <p>
            My work spanned choreographing full-length theater shows, directing digital video campaigns for showcases, and performing in various live productions. 
            By designing intricate partners, lifts, and weight-sharing sequences, we built physical expressions of emotional burden and support.
          </p>
        </div>
        <div className="right">
          <div className="metrics-box">
            <MetricCard>
              <h3>Residency Years</h3>
              <span>2014 — 2017</span>
              <p style={{fontSize: '0.85rem', opacity: 0.8, marginTop: '10px'}}>Served as choreographer and dancer across three key seasons.</p>
            </MetricCard>
            <MetricCard>
              <h3>Core Focus</h3>
              <span>THEATRICAL HIP-HOP</span>
              <ul>
                <li>Theater Show Choreography</li>
                <li>Live Showcase Performance</li>
                <li>Digital Promo Direction</li>
                <li>Partnership & Lift Mechanics</li>
              </ul>
            </MetricCard>
          </div>
        </div>
      </ChallengeSection>

      <SectionHeader style={{borderBottom: 'none'}}>
        <h2>Performance Gallery</h2>
        <span>SELECTED DIRECTED & CHOREOGRAPHED PIECES</span>
      </SectionHeader>

      <SolutionGrid>
        <div className="wide pop-image">
          <PopImage src={bp1} alt="Epic Lift Partner Sequence" title="Body Politic: Lift Sequence" />
        </div>
        <div className="pop-image">
          <PopImage src={bp3} alt="Close-up of Dancer Exertion" title="Body Politic: Solo Expression" />
        </div>
        <div className="pop-image">
          <PopImage src={bp4} alt="Dancers Bridging Together - Architectural Form" title="Body Politic: Collective Support" />
        </div>
        <div className="wide pop-image">
          <PopImage src={bp5} alt="Dancers Facing Off - Dynamic Tension" title="Body Politic: Dynamic Tension" />
        </div>
      </SolutionGrid>

      <ResultsSection>
        <div className="left">
          <h2>Reflections</h2>
          <p>
            Working within a dance company setting taught me how to align multiple performers to form a single, unified kinetic story.
            Choreographing hip-hop for the theater demands a balance between individual freedom and meticulous, geometric coordination.
          </p>
        </div>
        <div className="metrics-grid">
          <div className="result-stat">
            <h3>4</h3>
            <h4>Residency Years</h4>
            <p>Developing creative vocabulary</p>
          </div>
          <div className="result-stat">
            <h3>3+</h3>
            <h4>Productions</h4>
            <p>Theater shows and digital videos</p>
          </div>
        </div>
      </ResultsSection>
    </Page>
  );
};

export default BP;
